// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__T1iHX","toggleWrap":"styles_toggleWrap__3VTNW","content":"styles_content__1HL00","selectAreaCode":"styles_selectAreaCode__3ik_I"};